import { RouteConfig } from 'vue-router';

export default [{
  path: '',
  name: 'login',
  component: () => import('../containers/index.vue')
}] as Array<RouteConfig>;
